import { User } from "effno-core";
import { PublicDetails } from "../response-content/ResponseContent";
import "./CommentAvatar.css";

const COLOR_WHEEL = [
    "#FFB3BA", // Pastel Pink
    "#FFDFBA", // Pastel Peach
    "#FFFFBA", // Pastel Yellow
    "#BAFFC9", // Pastel Green
    "#BAE1FF", // Pastel Blue
    "#D5BAFF", // Pastel Lavender
    "#FFB6C1", // Light Pink
    "#FFDAB9", // Peach Puff
    "#B0E0E6", // Powder Blue
    "#F5DEB3"  // Wheat
];

type CommentAvatarProps = {
    publicDetails?: PublicDetails;
    user?: User;
}

export const CommentAvatar = ({publicDetails, user} : CommentAvatarProps) => {

    const color = publicDetails ? COLOR_WHEEL[publicDetails.publicName.charCodeAt(0) % 10] : "transparent";

    // console.log("[CommentAvatar] publicDetails: ", publicDetails);
    // console.log("[CommentAvatar] user: ", user);

    return (
        <div 
            className="public-avatar"
            style={{backgroundColor: color}}
        >
            {publicDetails &&
                <>
                    {publicDetails.publicName[0]}
                </>
            }  
            {!publicDetails &&
                <img src={user?.avatarURL || ""} alt="" />
            }  
        </div>
    )
}


 
